import { AppNavigationGuard } from '@sennder/shell-utilities'

import { INITIAL_ROUTE_PATH } from '@/router'
import {
  canAccessCharteringPages,
  canAccessContractManagementV2,
  canAccessShipperContactsPages,
  canAccessTransportAnalysis,
} from './user-access'
import { ENV, isProductionEnv } from '@/common/config'

/**
 * Router Navigation Guards
 *
 * NAMING CONVENTIONS
 *
 * Route guard name should be a verb that describes what the guard does.
 *
 * - check{Page}Access: Check if the user has access to the page
 * - redirect{Page}: Redirect the user to a different page based on some criteria
 * - restrict{Criteria}: Restrict access to the page based on some criteria
 */

/**
 * Redirect users to the Trip page.
 */
export const redirectToTrip: AppNavigationGuard = async (to) => {
  return `/trips/${to.params.orderGroupId}${to.params.letter}`
}

/**
 * Redirect users to the Customer Order page.
 */
export const redirectToCustomerOrder: AppNavigationGuard = async (to) => {
  return `/customer-order/${to.params.id}`
}

/**
 * Continue to the customer order route.
 */
export const redirectToShipment: AppNavigationGuard = async () => {
  return true
}

/**
 * Enable this page only in non-prod envs
 */
export const restrictInProduction: AppNavigationGuard = async () => {
  if (isProductionEnv()) {
    return { path: INITIAL_ROUTE_PATH }
  }
  return true
}

/**
 * This function determines whether the module should be visible to the user
 * based on the organization type.
 * Consider permission screen for the users that are not part of the chartering office
 */
export const restrictForCharteringOfficeUsers: AppNavigationGuard =
  async () => {
    if (canAccessCharteringPages()) {
      return true
    }
    return { path: INITIAL_ROUTE_PATH }
  }

export const checkShipperContactsAccess: AppNavigationGuard = () => {
  if (canAccessShipperContactsPages()) {
    return true
  }

  return { path: INITIAL_ROUTE_PATH }
}

export const redirectToSingleViewAP: AppNavigationGuard = () => {
  return '/single-view/ap-view/ap-view_all'
}

export const redirectToDefaultPage: AppNavigationGuard = () => {
  return { path: INITIAL_ROUTE_PATH }
}

export const canAcessTransportAnalysis: AppNavigationGuard = () => {
  if (canAccessTransportAnalysis()) {
    return true
  }

  return { path: INITIAL_ROUTE_PATH }
}

export const restrictToDev: AppNavigationGuard = () => {
  if (ENV === 'dev') {
    return true
  }

  return { path: INITIAL_ROUTE_PATH }
}

export const checkContractManagementV2Access: AppNavigationGuard = () => {
  if (canAccessContractManagementV2()) {
    return true
  }

  return { path: INITIAL_ROUTE_PATH }
}
